<template>
  <el-dialog
    v-el-drag-dialog
    :visible.sync="dialogVisible"
    :close-on-click-modal="false"
    title="工单发料"
    width="1400px"
    class="adaptationModal"
  >
    <el-table v-loading="loading" stripe border :data="model.bomList">
      <el-table-column type="index" label="#" width="55" align="center" />
      <el-table-column prop="materialNo" label="物料编号" width="110" align="center" show-overflow-tooltip />
      <el-table-column prop="materialName" label="物料名称" min-width="200" show-overflow-tooltip>
        <template slot-scope="scope">
          <span v-if="scope.row.isRed" style="color: red">{{ scope.row.materialName }}</span>
          <span v-else>{{ scope.row.materialName }}</span>
        </template>
      </el-table-column>
      <el-table-column prop="specification" label="规格型号" min-width="100" show-overflow-tooltip />
      <el-table-column prop="unitName" label="单位" width="70" align="center" />
      <el-table-column prop="outputQuantity" label="已发料数量" width="90" align="center"></el-table-column>
      <el-table-column label="当前仓库" width="180" align="center">
        <template slot-scope="scope">
          <el-input v-model="scope.row.warehouseName" placeholder="请选择" readonly>
            <el-button slot="append" icon="el-icon-search" @click="selectInventory(scope.row, scope.$index)" />
          </el-input>
        </template>
      </el-table-column>
      <el-table-column prop="locationName" label="当前仓位" width="100" align="center" show-overflow-tooltip />
      <el-table-column prop="baseQuantity" label="库存数量" width="80" align="center" />
      <el-table-column prop="actualQuantity" label="本次发料数量" width="95" align="center">
        <template slot-scope="scope">
          <el-input class="inputCenter" v-model="scope.row.actualQuantity" placeholder="请输入" @change="inputHandle(scope.row)" />
        </template>
      </el-table-column>
      <el-table-column prop="sum" label="总库存数量" width="85" align="center">
        <template slot-scope="scope">
          <span v-if="scope.row.isRed" style="color: red">{{ scope.row.sum }}</span>
          <span v-else>{{ scope.row.sum }}</span>
        </template>
      </el-table-column>
      <el-table-column prop="quantity" label="需求数量" width="80" align="center" />
    </el-table>
    <span slot="footer">
      <el-button @click="dialogVisible = false">取消</el-button>
      <el-button type="primary" :loading="submitLoading" @click="submitHandle">确定</el-button>
    </span>
    <InventorySelect ref="InventorySelect" @select="selectHandle"></InventorySelect>
  </el-dialog>
</template>

<script>
import InventorySelect from "@/views/StoreManagement/Inventory/InventorySelect.vue";
export default {
  components: { InventorySelect },
  data() {
    return {
      dialogVisible: false,
      loading: false,
      model: {
        bomList: [],
      },
      currentIndex: "",
      currentRow: null,
      submitLoading: false,
    };
  },

  methods: {
    open(pkid) {
      this.dialogVisible = true;
      this.getData(pkid);
    },

    // 获取发料明细
    getData(pkid) {
      this.$http.get("basic", `taskDispatchBills/${pkid}`).then((res) => {
        if (res.success) {
          res.data.bomList = res.data.bomList.filter((item) => item.feedingType !== 20); // 过滤掉物料投料类型为直接倒冲的数据
          res.data.bomList.forEach((item) => {
            item.locationName = "";
            item.locationNo = "";
            item.warehouseName = "";
            item.warehouseNo = "";
          });
          this.model = res.data;
          this.getInventoryByMaterialNos();
        }
      });
    },

    // 根据物料编号获取库存信息
    getInventoryByMaterialNos() {
      this.loading = true;
      let materialNos = [];
      this.model.bomList.forEach((item) => {
        materialNos.push(item.materialNo);
      });
      this.$http
        .get("basic", `stockDetails/kingdee/list?materialNos=${materialNos.join()}`)
        .then((res) => {
          if (res.success) {
            this.inventory = res.data;
            // 获取物料总库存数量
            this.model.bomList.forEach((item) => {
              let arr = this.inventory.filter((each) => each.materialNo == item.materialNo);
              arr.sort((a, b) => b.baseQuantity - a.baseQuantity);
              let sum = 0;
              if (arr.length) {
                arr.forEach((i) => {
                  sum += i.baseQuantity;
                });
                // 当前仓库、当前仓位赋值
                item.locationName = arr[0].locationName;
                item.locationNo = arr[0].locationNo;
                item.warehouseName = arr[0].warehouseName;
                item.warehouseNo = arr[0].warehouseNo;
                item.batchNo = arr[0].lot;
                item.stockId = arr[0].id;
                this.$set(item, "baseQuantity", arr[0].baseQuantity);
              }
              this.$set(item, "sum", sum);
              // 如果需求数量 减去 已发料数量 超出总库存数量 则标红
              if (sum < item.quantity - item.outputQuantity) {
                this.$set(item, "isRed", true);
              }
            });
            this.loading = false;
          }
        })
        .catch(() => {
          this.loading = false;
        });
    },

    selectInventory(row, index) {
      this.currentRow = row;
      this.currentIndex = index;
      this.$refs.InventorySelect.open(row.materialNo);
    },

    // 选择仓库
    selectHandle(row) {
      this.currentRow.locationNo = row.locationNo;
      this.currentRow.locationName = row.locationName;
      this.currentRow.warehouseName = row.warehouseName;
      this.currentRow.warehouseNo = row.warehouseNo;
      this.currentRow.baseQuantity = row.baseQuantity;
      this.currentRow.batchNo = row.lot;
      this.currentRow.stockId = row.id;
      this.$set(this.model.bomList, this.currentIndex, this.currentRow);
    },

    // 本次发料数量输入校验
    inputHandle(row) {
      let reg = /^\d+(\.\d+)?$/;
      if (!reg.test(+row.actualQuantity) || row.actualQuantity == 0) {
        this.$confirm("请输入大于0的数字", "错误", {
          type: "error",
          showCancelButton: false,
        });
        row.actualQuantity = "";
        return;
      }
      if (row.actualQuantity > row.baseQuantity) {
        this.$confirm("本次发料数量超出库存数量", "错误", {
          type: "error",
          showCancelButton: false,
        });
        row.actualQuantity = "";
        return;
      }
      if (row.actualQuantity > row.quantity - row.outputQuantity) {
        this.$confirm("本次发料数量超出未发货数量", "错误", {
          type: "error",
          showCancelButton: false,
        });
        row.actualQuantity = "";
        return;
      }
    },

    submitHandle() {
      let result = this.model.bomList.some((item) => !item.actualQuantity);
      if (result) {
        this.$confirm("请输入本次发料数量", "错误", {
          type: "error",
          showCancelButton: false,
        });
        return;
      }
      this.submitLoading = true;
      this.$http
        .post("basic", "productionManage/materialComplete", this.model)
        .then((res) => {
          if (res.success) {
            this.$message.success("发料成功");
            this.$emit("save-success");
            this.dialogVisible = false;
          }
          this.submitLoading = false;
        })
        .catch(() => {
          this.submitLoading = false;
        });
    },
  },
};
</script>
